import React from "react"
import PropTypes from "prop-types"
import AOS from "aos"

import "./../styles/layout.scss"

class Layout extends React.Component {
  componentDidMount() {
    AOS.init({
      duration: 1500,
      once: true,
    })
  }
  render() {
    return (
      <div>
        <main>{this.props.children}</main>
      </div>
    )
  }
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
